<template>
  <div>
    <!-- 24.5.17 功能按钮 dxm -->
    <el-row type="flex" class="button-wrap container" justify="space-between">
      <el-col
        :span="7"
        v-for="(item, index) in buttonList"
        :key="index"
        style="display: flex; justify-content: center"
      >
        <div class="button-list" @click="changebtn(item)">
          <span>{{ langSet == "cn" ? item.title : item.en_title }}</span>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="dialogVisible"
    >
      <img class="dialog_img" src="../../../assets/jqqd.jpg" />
      <div class="dialog_txt">
        {{ langSet == "cn" ? "敬请期待" : "Stay Tuned" }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sdkClick } from "../../../sdk/useSdk";
export default {
  data() {
    return {
      langSet: "",
      buttonList: [
        // {
        //   title: "参展报名",
        //   en_title: "Pre-registration",
        //   path: "https://reg.reed-sinopharm.com/pc/#/login?id=d53d1235522243d7b93a68f807e291cb&channelUuid=0543f50336364b32835da30986a10a1e",
        // },
        {
          title: "展商入口",
          en_title: "Exhibitor Login",
          path: "https://exhibitor.apichina.com.cn/#/login",
        },
        {
          title: "观众注册",
          en_title: "Visitor Registration",
          path: "https://reg.reed-sinopharm.com/pc/#/login?id=659bb0cb38224fd78ca6561569b277f5&channelUuid=defd903b76104eafba6f5179af068e1b",//26.8.25 更新链接 dxm 刘秀鸽
          en_path: "https://reg.reed-sinopharm.com/pc/#/login?id=659bb0cb38224fd78ca6561569b277f5&channelUuid=2a1544ffbbe44a7bbf1693ef85c9c8ae",
        },
        {
          title: "会议⼊⼝",
          en_title: "Conference Portal",
          path: "",
        },
      ],
      dialogVisible: false,
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    changebtn(item) {
      sdkClick("首页功能区", item.title);
      // 展商入口没有英文版，先展示敬请期待
      if (
        item.path === "https://exhibitor.apichina.com.cn/#/login" &&
        this.$language === "en"
      ) {
        this.dialogVisible = true;
        return false;
      }
      if (item.path || item.en_path) {
        if (
          item.path.indexOf("https") != -1 ||
          item.en_path.indexOf("https") != -1
        ) {
          window.open(
            this.langSet == "cn" ? item.path : item.en_path,
            "_blank"
          );
        } else {
          this.$router.push({
            name: item.path,
          });
        }
      } else {
        this.dialogVisible = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  width: 350px;
  height: 288px;
  background: #ffffff;
  border-radius: 12px;
  margin: auto;
  display: flex;
}
.dialog_img {
  width: 151px;
  height: 160px;
}
.dialog_txt {
  margin-top: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.button-wrap {
  // width: 1180px;
  margin-top: -204px;
  margin-bottom: 120px;
  position: relative;
  z-index: 9;
  .button-list {
    width: 300px;
    height: 68px;
    font-size: 21px;
    color: #001a33;
    line-height: 68px;
    text-align: center;
    background: #fff;
    border-radius: 60px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 2px solid rgba(29, 35, 121, 0.38);
    &:hover {
      color: #fff;
      font-weight: 500;
      background: #1d2379;
      border: 2px solid rgba(255, 255, 255, 0.38);
    }
  }
}
// 移动端
@media only screen and (max-width: 1280px) {
  .button-wrap {
    margin-top: -165px;
    margin-bottom: 20px;
    .button-list {
      height: 70px;
    }
  }
}
// 移动端
@media only screen and (max-width: 1000px) {
  .button-wrap {
    margin-top: -88px;
    margin-bottom: 20px;
    .button-list {
      height: 70px;
    }
  }
}
// 移动端
@media only screen and (max-width: 768px) {
  .dialog {
    width: 250px;
    height: 200px;
  }
  .dialog_img {
    width: 91px;
    height: 100px;
  }
  .dialog_txt {
    font-size: 14px;
    margin-top: 20px;
  }
  .button-wrap {
    margin-top: 40px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    & > div {
      width: 100%;
      display: block !important;
      margin-bottom: 10px;
    }
    .button-list {
      width: 5.77rem;
      height: 1.12rem;
      height: 58px;
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.12rem;
      background: #1d2379;
      border-radius: 60px;
      margin: 0 auto;
      border: 2px solid rgba(255, 255, 255, 0.38);
      // span {
      //   display: inline-block;
      //   width: 70px;
      // }
      .button-icon {
        width: 14px;
        margin-right: 10px;
        margin-left: 5px;
      }
    }
  }
}
// 移动端
@media only screen and (max-width: 484px) {
  .dialog {
    width: 250px;
    height: 200px;
  }
  .dialog_img {
    width: 91px;
    height: 100px;
  }
  .dialog_txt {
    font-size: 14px;
    margin-top: 20px;
  }
  // .button-wrap {
  //   margin-top: -44px;
  //   margin-bottom: 20px;
  //   .button-list {
  //     height: 30px;
  //     font-size: 10px;
  //     border-radius: 5px;
  //     span {
  //       display: inline-block;
  //       width: 70px;
  //     }
  //     .button-icon {
  //       width: 14px;
  //       margin-right: 10px;
  //       margin-left: 5px;
  //     }
  //   }
  // }
}
</style>
<style lang="scss">
.dialog .el-dialog__header {
  padding: 0;
}
.dialog .el-dialog {
  width: 100%;
  margin-top: 0 !important;
  box-shadow: initial !important;
}
.dialog .el-dialog__body {
  flex-direction: column;
  display: flex;
  align-items: center;
}
</style>